import BaseRoute from 'uplisting-frontend/pods/base/route';

export default class LogoutRoute extends BaseRoute {
  async activate() {
    await this.session.handleLogout();
  }
}
